import React from "react";

import { ChevronIcon } from "@packages/ds";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";

import {
  setEnvironmentsContext,
  selectEnvironmentsPanelExpanded
} from "Reducers/settingsMenu";

import EnvironmentTree from "./EnvironmentTree";
import { MenuChildrenContainer, MenuHeader, Submenu } from "./Menu.styles";

const EnvironmentSettingsMenu = () => {
  const expanded = useSelector(selectEnvironmentsPanelExpanded);
  const dispatch = useDispatch();
  const intl = useIntl();

  return (
    <MenuChildrenContainer expanded={expanded}>
      <MenuHeader
        onClick={() => {
          dispatch(setEnvironmentsContext());
        }}
      >
        <h1>
          {intl.formatMessage({ id: "settings.menu.environment_settings" })}
        </h1>
        <ChevronIcon direction={expanded ? "up" : "down"} />
      </MenuHeader>
      {expanded && (
        <Submenu>
          <EnvironmentTree />
        </Submenu>
      )}
    </MenuChildrenContainer>
  );
};

export default EnvironmentSettingsMenu;
